import { useEffect, useState } from "react";
import { Outlet,  useLocation, } from "react-router-dom";

import {
  TopBar,
  Navbar,
  Footer,
} from "../components/web-app/index";

import BackToTop from "./BackToTop/backtotop";
import WhatsAppButton from "./WatsapButton/Watsapbutton";

import LoginOtpPopup from "../auth/Login-Otp/LoginotpPopup";
import LoginPasswordPopup from "../auth/Login-Otp/Loginpassword";
import VerifyLoginOtp from "../auth/Login-Otp/LoginVerifyOtp";

const WebWrapperLayout = () => {
    const location = useLocation();
  /* =====================================================
     VERIFY OTP POPUP STATE
  ===================================================== */

  const [showVerifyOtp, setShowVerifyOtp] = useState(false);

  const [verifyOtpLogin, setVerifyOtpLogin] = useState("");


  /* =====================================================
   OPEN LOGIN OTP FROM ADMIN LOGIN

   Admin Login navigates to:
   /
   state={{ openLoginOtp: true }}

   Once WebWrapperLayout is mounted,
   open the global LoginOtpPopup.
===================================================== */

useEffect(() => {
  if (location.state?.openLoginOtp) {
    const timer = setTimeout(() => {
      window.dispatchEvent(
        new CustomEvent("open-login-otp")
      );

     
      window.history.replaceState(
        {},
        document.title,
        window.location.pathname
      );
    }, 0);

    return () => {
      clearTimeout(timer);
    };
  }
}, [location.state]);

  /* =====================================================
     OPEN VERIFY OTP POPUP
     
     This is GLOBAL.
     Any page can trigger:
     
     open-login-otp-verify
  ===================================================== */
  useEffect(() => {
    const handleOpenVerifyOtp = (event) => {
      const login = event?.detail?.login;

      console.log(
        "GLOBAL: open-login-otp-verify",
        login
      );

      if (!login) {
        return;
      }

      setVerifyOtpLogin(login);
      setShowVerifyOtp(true);
    };

    window.addEventListener(
      "open-login-otp-verify",
      handleOpenVerifyOtp
    );

    return () => {
      window.removeEventListener(
        "open-login-otp-verify",
        handleOpenVerifyOtp
      );
    };
  }, []);


  /* =====================================================
     CLOSE VERIFY OTP POPUP
  ===================================================== */

  const handleCloseVerifyOtp = () => {
    setShowVerifyOtp(false);
    setVerifyOtpLogin("");
  };


  /* =====================================================
     OPEN LOGIN OTP POPUP AGAIN
     
     Used when Verify OTP wants to go back to
     Login OTP popup.
  ===================================================== */

  useEffect(() => {
    const handleOpenLoginOtp = () => {
      console.log(
        "GLOBAL: open-login-otp"
      );

      setShowVerifyOtp(false);
      setVerifyOtpLogin("");

      /*
       * LoginOtpPopup is already listening
       * for this event.
       */
      window.dispatchEvent(
        new CustomEvent("open-login-otp")
      );
    };

    window.addEventListener(
      "open-login-otp",
      handleOpenLoginOtp
    );

    return () => {
      window.removeEventListener(
        "open-login-otp",
        handleOpenLoginOtp
      );
    };
  }, []);


  /* =====================================================
     UI
  ===================================================== */

  return (
    <>
      <TopBar />

      <Navbar />


      {/* =================================================
          GLOBAL LOGIN OTP POPUP
      ================================================= */}

      <LoginOtpPopup />


      {/* =================================================
          GLOBAL LOGIN PASSWORD POPUP
      ================================================= */}

      <LoginPasswordPopup />


      {/* =================================================
          GLOBAL VERIFY OTP POPUP
          
          This is the important part.
          It is now available on:
          
          Home
          Shop
          Category
          Product Details
          Cart
          etc.
      ================================================= */}

      {showVerifyOtp && verifyOtpLogin && (
        <VerifyLoginOtp
          login={verifyOtpLogin}
          onClose={handleCloseVerifyOtp}
        />
      )}


      {/* =================================================
          PAGE CONTENT
      ================================================= */}

      <main>
        <Outlet />
      </main>


      <Footer />

      <WhatsAppButton />

      <BackToTop />
    </>
  );
};

export default WebWrapperLayout;